var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.46,
    height: 24.48,
    viewBox: "0 0 22.46 24.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26,9.82V18.1a1,1,0,0,1-2,0V9.82a1,1,0,0,1,2,0Zm4.71-1a1,1,0,0,0-1,1V18.1a1,1,0,0,0,2,0V9.82A1,1,0,0,0,14,8.82Zm8.49-4.39a1,1,0,0,1-1,1H21l-.9,15.84a3.4,3.4,0,0,1-3.39,3.21H5.55a3.41,3.41,0,0,1-3.4-3.21L1.25,5.43H1a1,1,0,0,1,0-2H4.87L5.5,1.64A2.4,2.4,0,0,1,7.8,0h6.62a2.42,2.42,0,0,1,2.31,1.64l.62,1.79h4.11A1,1,0,0,1,22.46,4.43ZM7,3.43h8.25l-.4-1.13a.43.43,0,0,0-.42-.3H7.8a.43.43,0,0,0-.42.3Zm12,2H3.26l.89,15.73a1.4,1.4,0,0,0,1.4,1.32H16.68a1.41,1.41,0,0,0,1.4-1.32Z",
    fill: "#624de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6e0399db7a964f7f75074f2ff19f07db.svg";
export { ForwardRef as ReactComponent };